/******************************************************************************
 *
 * Copyright (c) 2019-2022 ServiceActivator Inc. All Rights Reserved.
 *
 * Unauthorized copying of the code in this file, completely or partially,
 * via any medium is strictly prohibited.
 *
 * Proprietary and Confidential.
 *
 * Written by 'Shivam Mishra' <shivam.mishra@wakencode.com>, June 2022
 *
 *****************************************************************************/

import React, { useEffect, useState } from "react";
import { SALoader } from "../../loader/SALoader";
import Footer from "../../footer/Footer";
import {
  activateEmployee,
  activateNewEmployee,
  activateOwner,
  createSubscriber,
  inviteSubscriberOwner,
  updateInfo,
} from "../../network";
import { string } from "../../constant/string";
import { useUser } from "../../context/UserContext";
import { useAuth } from "../../context/AuthContext";
import { updateJourneyStage } from "../../container/postDataFormat";

/**
 * Activaing account called in Wrapper.js
 *
 * @param {*} setPage State for current page
 * @returns JSX for activating account
 */
const ActivatingAccount = ({ setPage, isInvited, jobRole }) => {
  // State for loader
  const [loading, setLoading] = useState(false);
  //State to set user data from user context
  const { userData, setUserData } = useUser("");
  // State to set token from auth context
  const { token, setToken } = useAuth("");

  const config = {
    headers: { Authorization: `Bearer ${token}` },
  };

  useEffect(() => {
    if (isInvited) {
      // Call api to activate employee account
      callApiToActivateInvitedEmployee();
    } else {
      if (jobRole === "employee") {
        //if job role is 'employee'
        //invite or send the marketing email to the subscriber's(subscriber of new employee) owner
        callApiToInviteSubscriberOwner();
        // Call api to activate new employee
        callApiToActivateNewEmployee();
      } else {
        // Call api to activate owner account
        callApiToCreatesubscriber();
      }
    }
  }, []);

  /**
   * Api to create subscriber
   */
  const callApiToCreatesubscriber = () => {
    setLoading(true);
    //set auth header

    createSubscriber(config)
      .then((response) => {
        if (response.status == 200) {
          callApiToActivateOwner();
        }
        setLoading(false);
      })
      .catch((err) => {
        if (err?.response?.status === 401) {
          setToken("")
          setPage("SignUp");
        } else {
          setPage("AccountFailed");
        }
        setLoading(false);
      });
  };

  /**
   * Api to activate owner
   */
  const callApiToActivateOwner = () => {
    //set auth header

    activateOwner(config)
      .then(() => {
        setPage("AccountActivated");
        setLoading(false);
      })
      .catch((err) => {
        if (err?.response?.status === 401) {
          setToken("")
          setPage("SignUp");
        } else {
          setPage("AccountFailed");
        }
        setLoading(false);
      });
  };

  /**
   * Api to invite or send marketing email to the subscriber owner
   */
  const callApiToInviteSubscriberOwner = async () => {
    setLoading(true);
    try {
      await inviteSubscriberOwner(config);
    } catch (err) {
      // setLoading(false);
      if (err?.response?.status === 401) {
        setToken("")
        setPage("SignUp");
      }
    }
  };

  /**
   * Api to activate invited employee
   */
  const callApiToActivateInvitedEmployee = () => {
    setLoading(true);

    activateEmployee(config)
      .then(() => {
        setPage("AccountActivated");
        setLoading(false);
      })
      .catch((err) => {
        if (err?.response?.status === 401) {
          setToken("")
          setPage("SignUp");
        } else {
          setPage("AccountFailed");
        }
        setLoading(false);
      });
  };

  /**
   * Api to activate new employee
   */
  const callApiToActivateNewEmployee = () => {
    setLoading(true);

    activateNewEmployee(config)
      .then(() => {
        setPage("AccountActivated");
        setLoading(false);
      })
      .catch((err) => {
        if(err?.response?.status === 401) {
          setToken("")
          setPage("SignUp");
        }else{
          setPage("AccountFailed");
        }
          setLoading(false);
      });
  };

  return (
    <>
      <div className="finalPageMain">
        {/* Parant container */}
        <div className="parantContainer">
          {/* Loader for the page */}
          <div className="mainText">
            <SALoader />
            {/* Main text on the screen */}
            {string.ACTIVATING_YOUR_ACCOUNT} <br />
            <br />
            <div className="paraText">
              {string.PLEASE_WAIT} <br />
              <br /> {string.WILL_TAKE_TIME} <br />
              <br /> {string.DO_NOT_REFRESH}
              {jobRole === "employee" && (
                <>
                  <br />
                  <br /> {string.REACH_COMPANY_OWNER}
                </>
              )}
            </div>
          </div>
        </div>
      </div>
      {/* Footer on the screen */}
      <Footer />
    </>
  );
};

export default ActivatingAccount;
